import { graphql } from "../generated/gql";

export const FeaturesFlags = graphql(`
  query FeaturesFlags($names: [String!]) {
    getFeatureFlags(names: $names) {
      name
      isEnabled
    }
  }
`);
